<template>
  <div>

  <!-- toasts message -->
  <Snackbar :SnackbarVal="SnackbarVal"></Snackbar>
  <!-- /toasts message -->

<!--___________Form_____________ -->
    <v-card>
      <v-card-title class="pb-0">
        <span class="headline">Search Disbursement</span>
      </v-card-title>
      <v-form v-model="valid" ref="form" lazy-validation class="mt-0">
        <v-card-text>
          <v-container grid-list-md class="py-0">
            <v-layout wrap>
              <v-flex xs12 sm6 md6 offset-md3>
               <v-autocomplete
                label="Loan Number *"
                item-text="loan_no"
                item-value="id"
                v-model="formSchema.loan_id"
                :items="loanNoList"
                :rules="[v => !!v || 'Loan number is required !']"
                required
                @change="getClientName(formSchema.loan_id)"
              ></v-autocomplete>
              </v-flex>
              
              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Sub-Project Name"
                v-model="sub_project_name"                                
                readonly
              ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 md6>
                <v-text-field
                label="Client Name *"
                v-model="formSchema.client_name"
                :rules="[v => !!v || 'Client name is required !']"
                required
                readonly
              ></v-text-field>
              </v-flex>
              
              <v-flex xs12 sm6 md6 offset-md3>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="success" @click.native="searchInfo" :disabled="!valid">
                    <v-icon>search</v-icon>
                    Search
                  </v-btn>
                </v-card-actions>
              </v-flex>

            </v-layout>
          </v-container>
        </v-card-text>
      </v-form>
    </v-card>
    <!-- _____________/Form_____________ -->

    <v-card-title>
      <h2>Disbursement List</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.loan_no }}</td>
        <td class="text-xs-left">{{ props.item.voucher_number }}</td>
       <!--  <td class="text-xs-left">{{ props.item.eco_account_name }}</td>
        <td class="text-xs-left">{{ props.item.eco_account_code }}</td> -->

        <td class="text-xs-left">{{ props.item.disbursement_amount }}</td>
        <td class="text-xs-left">{{ props.item.currency_code }}</td>
        <td class="text-xs-left">{{ props.item.currency_rate }}</td>
        <td class="text-xs-left">{{ props.item.bdt_amount }}</td>
        <td class="text-xs-left">{{ props.item.usd_amount }}</td>
        <td class="textCenter">
          <span>
            <v-btn title="Edit" icon class="mx-0" @click="editDisbursement(props.item)">
              <v-icon color="teal">edit</v-icon>
            </v-btn>
          </span>
        </td>
      </template>
    </v-data-table>

  </div>
</template>


<script>
const commonService = require("../../../services/common.service");
import Axios from "axios";

export default {
  data: () => ({
    valid: true,
    projectList:[],
    loanNoList:[],
    leaveTypeModal: false,
    detailObject:'',
    sub_project_name:'',

    SnackbarVal: {
      snackbar: false,
      color: "success",
      message: ""
    },

    formSchema: {
      id: 0,
      project_name_short: "",
      loan_id: "",
      client_name:"",
    },


    /*------------- Datatable ---------------*/
    serialNumber: 0,
    sort: "",
    queryData: {
      sortBy: "id",
      descending: true,
      page: 1,
      rowsPerPage: 5,
      totalItems: 0,
      search_val: ""
    },

    search: "",
    totalDesserts: 0,
    desserts: [],
    loading: true,
    pagination: {},

    headers: [
      {
        text: "SL",
        value: ""
      },
      {
        text: "Loan No", align: "left", sortable: true, value: "loan_no"
      },
      {
        text: "Voucher Number", align: "left", sortable: true, value: "voucher_number"
      },
      /*{
        text: "Economic Account Name", align: "left", sortable: true, value: "eco_account_name"
      },
      {
        text: "Economic Account Code", align: "left", sortable: true, value: "eco_account_code"
      },*/

      {
        text: "Disbursement Amount", align: "left", sortable: true, value: "disbursement_amount"
      },
      {
        text: "Currency", align: "left", sortable: true, value: "currency_code"
      },
      {
        text: "Currency Rate", align: "left", sortable: true, value: "currency_rate"
      },
      {
        text: "BDT Amount", align: "left", sortable: true, value: "bdt_amount"
      },
      {
        text: "USD Amount", align: "left", sortable: true, value: "usd_amount"
      },
      {
        text: "Action", align: "left"
      },
      
    ],
    /*------------- /Datatable ---------------*/
    
  }),


  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    },

    userRole: function(){}
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },

    userRole() {
      //console.log('userRole');
      let role = this.$store.getters.get_USER_ROLE_DATA;
      this.showForm = role.saveButton;
      return role;
    }
  },
  /*------------/Datatable------------*/

  created(){
    this.$store.commit('UNSET_SEARCH_DISBURSEMENT_DATA');
    commonService.getAllData("get-dis-dropdown-data-dis").then(res => {        
        this.loanNoList = res.loanNoList;
    });
  },

  methods: {
     /*-----------------Edit Disburstment----------------*/
    editDisbursement(items)
    {
        
        commonService.dataByMulParameters(items,'disbursement').then(res => {
          if(res.status == 0)
          {
            this.SnackbarVal.color = "error"            
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;
          }
          else
          {
            this.SnackbarVal.color = "success"
            items.is_edit = true   
            items.disbursement_accountInfo = res.disbursement_accountInfo 
            items.client_name = res.data.client_name 
            items.short_name = res.data.short_name 
            items.loan_amount = res.data.loan_amount 
            items.disbursement_amount = res.data.loan_amount 
            this.$store.commit('SEARCH_DISBURSEMENT_DATA',items); 
            this.$router.push("/on-lending/disbursement");   
          }
          
        });


      //console.log('items', items);
      //this.$store.commit('SEARCH_DISBURSEMENT_DATA',items); 
      //this.$router.push("/on-lending/disbursement");
    },

    /*-----------------Datatable----------------*/
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();

        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService.getServerSideData(query_Data, "disbursement-list").then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    /*-----------------/Datatable----------------*/

    searchInfo()
    {       
      this.$store.commit('UNSET_SEARCH_DISBURSEMENT_DATA');

       if (this.$refs.form.validate()) {  
        let formSchema = this.formSchema
        commonService.dataByMulParameters(formSchema,'disbursement').then(res => {
          if(res.status == 0)
          {
            this.SnackbarVal.color = "error"            
            this.SnackbarVal.message = res.message;
            this.SnackbarVal.snackbar = true;
          }
          else
          {

            this.SnackbarVal.color = "success"   
           let data = res.data;
           data['loan_id'] = data.id;
           data['available_amount'] = (data.loan_amount - data.disbursement_amount)
           data['disbursement_amount'] = (data.loan_amount)
           data['is_edit'] = false
           data['voucher_number'] = res.voucher_number   
           data['disbursement_accountInfo'] = res.disbursement_accountInfo 

           this.$store.commit('SEARCH_DISBURSEMENT_DATA',data); 
           this.$router.push("/on-lending/disbursement");  
          }
          
        });
      }
    },

    getClientName(loanId){
      let Loan = this.loanNoList.filter(function(a) {
                    return a.id == loanId;
                  })[0];
      this.formSchema.client_name  = Loan.client_name;
      this.sub_project_name  = Loan.sub_project_name;
    },
   
    close(res) {
      this.leaveTypeModal = false;      
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/lending/disbursement/search_form.vue